import React from 'react'
import PropTypes from 'prop-types'
import { useVariables } from '../../../../providers/VariableProvider'

function Hide ({
  applyTo,
  expectedValue,
  defaultValue,
  children
}) {
  const { getVariable } = useVariables()

  const variableValue = getVariable(applyTo, defaultValue)
  if (variableValue === expectedValue) {
    return null
  }

  return (
    <>
      {children}
    </>
  )
}

Hide.propTypes = {
  applyTo: PropTypes.string,
  expectedValue: PropTypes.any,
  defaultValue: PropTypes.any,
  children: PropTypes.any
}

Hide.defaultProps = {
  defaultValue: ''
}

export default Hide
